import React from 'react';
import PropTypes from 'prop-types';
import isTouchDevice from '../../../../lib/isTouchDevice';
import { l_check } from '../../../../icons';
import Icon from '../../Icon';
import { BASE_CLASSES, ICON_CLASS, BASE_PROP_TYPES, BASE_DEFAULT_PROPS } from './constants';
import './index.scss';

const Option = ({ children, value, disabled, hidden }) => (
    <option className={BASE_CLASSES}
        value={value}
        hidden={hidden}
        disabled={disabled}>
        {children}
    </option>
);

Option.propTypes = { ...BASE_PROP_TYPES };
Option.defaultProps = { ...BASE_DEFAULT_PROPS };

const OptionWrapper = ({ children, index, onChange, value, selected, disabled, key }) => {
    const Element = isTouchDevice ? 'option' : 'button';

    return (
        <Element onClick={(e) => onChange(e, index)}
            className={BASE_CLASSES}
            value={value}
            key={key}
            disabled={disabled}>
            {!isTouchDevice && <span className={ICON_CLASS}>
                {selected && (
                    <Icon size={11}>
                        {l_check}
                    </Icon>
                )}
            </span>}
            {children}
        </Element>
    );
};

OptionWrapper.propTypes = {
    ...BASE_PROP_TYPES,
    index: PropTypes.number.isRequired,
    onChange: PropTypes.func,
    selected: PropTypes.bool,
    key: PropTypes.string
};

OptionWrapper.defaultProps = {
    ...BASE_DEFAULT_PROPS,
    onChange: () => null,
    selected: false
};

export {
    Option,
    OptionWrapper
};
